/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React,{useState} from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import HeaderContext from '../Context/HeaderContext';
import Header from '../Header';
import RaiseTicket from '../RaiseTicket';
import ReactModal from 'react-modal';


export default function Layout({ children }) {
    const [isPopup, setisPopup] = useState(false);
    const [ErrorMessage, SetErrorMessage] = useState('');
    const [SuccessMessage, SetSuccessMessage] = useState('');
    const [colorValue, setcolorValue] = useState(false);
    const [cartCount, setcartCount] = useState(0)
    const [raiseTicket, setraiseTicket] = useState(false)
    return (
        <div>
            <HeaderContext.Provider value={{ isPopup,
                setisPopup,
                ErrorMessage,
                SetErrorMessage,
                SuccessMessage,
                SetSuccessMessage,
                colorValue,
                setcolorValue,cartCount,
                setraiseTicket,
                raiseTicket,
                setcartCount }}>
                <Header />
                <div>
                    <Outlet />

                    {children}
                </div>
                <ReactModal isOpen={raiseTicket}>
                    <RaiseTicket/>
                </ReactModal>
                <Footer />
            </HeaderContext.Provider>

        </div>
    );
}
